import {
  EntityRiskProfileTypeId,
  EntityRiskProfileTypeLabel,
} from '@converge/data';
import { useEntitiesAttackSurfaceCountsQuery } from '@converge/graphql';
import { useState } from 'react';
import {
  EntitiesDomainModal,
  EntitiesIpAddressesModal,
  EntitiesIpAddressOpenPortsModal,
  EntitiesVulnerabilitiesModal,
} from './risk-profile-modal';

import {
  CircularLoader,
  PaperLayout,
  StackLayout,
} from '../../../presentation/components';

import './underwriting.submission.detail.risk-profile.attack-surface.scss';

interface IProps {
  submissionUuid: string;
}

export const UnderwritingSubmissionDetailRiskProfileAttackSurface = ({
  submissionUuid,
}: IProps) => {
  const [currentOpenModal, setCurrentOpenModal] = useState<string | null>(null);

  const { loading, counts } =
    useEntitiesAttackSurfaceCountsQuery(submissionUuid);

  return (
    <>
      <StackLayout justifyContent="space-between">
        <UnderwritingSubmissionDetailRiskProfileAttackSurface.CountCard
          id={EntityRiskProfileTypeId.Domains}
          label={EntityRiskProfileTypeLabel.Domains}
          count={counts.domains}
          onClick={() => {
            setCurrentOpenModal(EntityRiskProfileTypeId.Domains);
          }}
          isLoading={loading}
        />
        <UnderwritingSubmissionDetailRiskProfileAttackSurface.CountCard
          id={EntityRiskProfileTypeId.IpAddress}
          label={EntityRiskProfileTypeLabel.IpAddress}
          count={counts.ipAddresses}
          onClick={() => {
            setCurrentOpenModal(EntityRiskProfileTypeId.IpAddress);
          }}
          isLoading={loading}
        />
        <UnderwritingSubmissionDetailRiskProfileAttackSurface.CountCard
          id={EntityRiskProfileTypeId.OpenPorts}
          label={EntityRiskProfileTypeLabel.OpenPorts}
          count={counts.openPorts}
          onClick={() => {
            setCurrentOpenModal(EntityRiskProfileTypeId.OpenPorts);
          }}
          isLoading={loading}
        />
        <UnderwritingSubmissionDetailRiskProfileAttackSurface.CountCard
          id={EntityRiskProfileTypeId.Vulnerabilities}
          label={EntityRiskProfileTypeLabel.Vulnerabilities}
          count={counts.vulnerabilities}
          onClick={() => {
            setCurrentOpenModal(EntityRiskProfileTypeId.Vulnerabilities);
          }}
          isLoading={loading}
        />
      </StackLayout>
      {currentOpenModal === EntityRiskProfileTypeId.Domains && (
        <EntitiesDomainModal
          submissionUuid={submissionUuid}
          onClose={() => setCurrentOpenModal(null)}
        />
      )}
      {currentOpenModal === EntityRiskProfileTypeId.IpAddress && (
        <EntitiesIpAddressesModal
          submissionUuid={submissionUuid}
          onClose={() => setCurrentOpenModal(null)}
          totalRows={counts.ipAddresses}
        />
      )}
      {currentOpenModal === EntityRiskProfileTypeId.OpenPorts && (
        <EntitiesIpAddressOpenPortsModal
          submissionUuid={submissionUuid}
          onClose={() => setCurrentOpenModal(null)}
          totalRows={counts.openPorts}
        />
      )}
      {currentOpenModal === EntityRiskProfileTypeId.Vulnerabilities && (
        <EntitiesVulnerabilitiesModal
          submissionUuid={submissionUuid}
          onClose={() => setCurrentOpenModal(null)}
          totalRows={counts.vulnerabilities}
        />
      )}
    </>
  );
};

interface IUnderwritingSubmissionDetailRiskProfileAttackSurfaceCountCardProps {
  isLoading: boolean;
  label: string;
  id: string;
  count: number | null | undefined;
  onClick(): void;
}

UnderwritingSubmissionDetailRiskProfileAttackSurface.CountCard = ({
  isLoading,
  label,
  id,
  onClick,
  count,
}: IUnderwritingSubmissionDetailRiskProfileAttackSurfaceCountCardProps) => {
  return (
    <PaperLayout elevation={1} data-testid={`risk-profile-${id}-count-card`}>
      <StackLayout spacing={0} className="risk-profile-count" onClick={onClick}>
        <span className="count-text">
          {isLoading ? (
            <CircularLoader
              padding={1}
              size={'27px'}
              style={{ color: ' #28c0a7' }}
            />
          ) : (
            count ?? '?'
          )}
        </span>
        <span className="count-label">{label}</span>
      </StackLayout>
    </PaperLayout>
  );
};
